import * as React from "react";
import {Panel} from "./Panel";

export interface CollapsiblePanelProps
{
	title: string;
	isOpened: boolean;
	className?: string;
	hideTitle?: boolean;
}

export class CollapsiblePanel extends React.Component<CollapsiblePanelProps, any>
{
	render()
	{
		let propClass = this.props.className;
		let className = propClass !== undefined && propClass !== null && propClass !== "" ? "collapse " + propClass : "collapse";
		return <div className={className} ref={(ref: HTMLElement) => { this.handleCollapse(ref); } }>
			<Panel title={ this.props.title } hideTitle={this.props.hideTitle}>
				       {this.props.children}
			       </Panel>
		       </div>;
	}

	handleCollapse(element: HTMLElement)
	{
		setTimeout(() =>
			{
				if (this.props.isOpened)
				{
					$(element).collapse("show");
				} else
				{
					$(element).collapse("hide");
				}
			},
			0);
	}
}


// WEBPACK FOOTER //
// ./src/components/common/CollapsiblePanel.tsx